"use client"

// Client half of the attribution claim. Fired next to the existing
// CompleteRegistration pixel calls, which are already the canonical "an
// account was just created" points in this codebase.
//
// Deliberately fire-and-forget and deliberately silent: a signup must never
// fail, or block, because a reporting write did. keepalive so the request
// survives the redirect that follows every signup — without it the fetch is
// cancelled when the page unloads and the attribution is lost precisely on the
// paths that have one.
export function claimAttribution(): void {
  try {
    void fetch("/api/attribution/claim", {
      method: "POST",
      keepalive: true,
    }).catch(() => {})
  } catch {
    // Never surfaces to the user.
  }
}
